<script lang="ts">
  import { setContext } from "svelte"
  import Footer from "./Footer.svelte"
  import Flash from "./Flash.svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()

  let {
    current_user,
    plan,
    children,
    params
  }: {
    current_user: UserType
    plan: PlanType
    children: Snippet
    params: any
  } = props

  appStore.plan = plan
  appStore.current_user = current_user

  import logo from "@images/logo/logo_white_small.png"
</script>

<svelte:head>
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-RXGMN2WVWL">
  </script>
  <script>
    window.dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())
    gtag("config", "G-RXGMN2WVWL")
  </script>
</svelte:head>

<div id="main-layout">
  <nav class="bg-lwp-accent shadow" id="main-nav">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 main-nav">
      <div class="relative flex items-center justify-between h-16">
        <div class="flex-1 flex items-center items-stretch justify-start">
          <div class="flex-shrink-0 flex items-center">
            <img src={logo} class="h-12 w-auto" alt="Lead With Purpose" />
          </div>
        </div>
      </div>
    </div>
  </nav>
  <div id="plan-header"></div>

  <main class="bg-lwp-pale-grey">
    <Flash flash={appStore.flash} />

    <div class="max-w-7xl mx-auto md:py-2 sm:px-6 lg:px-8">
      <div>
        {@render children()}
      </div>
    </div>
  </main>

  <Footer />
</div>
